module.exports = __webpack_public_path__ + "img/facebook.a6a8890d.svg";